//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "Start",

  mounted() {
    this.redirect();
  },

  updated() {
    this.redirect();
  },

  computed: {
    ...mapGetters(["currentClient"]),
  },

  methods: {
    navigateToDashboard() {
      this.$router.push({name: 'dashboard'});
    },
    navigateToWizard() {
      this.$router.push({name: 'wizard'});
    },
    redirect() {
      const alreadyVisited = window.localStorage.getItem("already-visited");
      if (alreadyVisited && this.$route.name !== 'onboarding') {
        if (this.currentClient.isManager) {
          this.$router.push({name: 'dashboard'});
        } else {
          this.$router.push({name: 'missions'});
        }
      }
      window.localStorage.setItem("already-visited", 'true');
    },
  }
}
